require("jquery-ui")
require("tag-it")

$(document).on("turbolinks:load", () => {
  $('#modal').on('mouseover', function(){
    if ($("#tag-it").length) {
      $("#tag-it").tagit({
        autocomplete: {source: "/matters/tag_auto_complete.json", delay: 300, minLength: 1}
      })
      return false;
    }
  });
})